module.exports = __webpack_public_path__ + "img/weather16.be0bcf5a.png";